import { createTheme } from "@mui/material/styles";

/**
 * If you want to add additional styles you need to add them to your config
 * and to the theme.extend.d.ts
 */

export default createTheme({
  typography: {
    fontFamily: "Poppins,Helvetica,Arial,Lucida,sans-serif",
    h3: {
      color: "#333",
      paddingBottom: "10px",
      lineHeight: "1em",
      fontWeight: 500,
      fontSize: "26px",
    },
  },

  palette: {
    primary: {
      main: "#e09a00",
      contrastText: "#fff",
    },
    spotify: {
      main: "#22c95c",
      contrastText: "#fff",
    },
    secondary: {
      main: "#414958",
      contrastText: "#fff",
    },
    warning: {
      main: "#FFC02E",
      contrastText: "#fff",
    },
    info: {
      main: "#1a9fa8",
      contrastText: "#fff",
    },
    success: {
      main: "#9AD425",
      contrastText: "#fff",
    },
    error: {
      main: "#E72413",
      contrastText: "#fff",
    },
    menu: {
      active: "#0274bb",
      inactive: "#fff",
      textActive: "#fff",
      textInactive: "#000",
    },
    header: {
      background: "#fff",
      contrastText: "#000",
      elevation: 1,
    },
    footer: {
      background: "#ededf0",
      contrastText: "#000",
      elevation: 1,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: "100px",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "standard",
      },
    },

    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: Poppins,Helvetica,Arial,Lucida,sans-serif;
          font-style: normal;
          font-display: swap;
          font-weight: 400;
          unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
        }
      `,
    },
  },
  // Example for additional type
  //   status: {
  //     danger: orange[500],
  //   },
});
